// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Applications_establishments__3m2FL","header":"Applications_header__2yg8W","tableHeader":"Applications_tableHeader__2Rcj1"};